<template>
  <div class="errorContent">
    <div class="errorContent__header">
      <div class="errorContent__headerInner">
        <div class="errorContent__headerContent">
          <h1 class="errorContent__headerTitle">Ups... Coś poszło nie tak</h1>
          <div class="errorContent__headerText">
            Ta strona nie istnieje. Prawdopodobnie została usunięta lub przeniesiona.
          </div>
          <v-button
            text="Wróć na Stronę Główną"
            theme="purple"
            :to="localePath({ name: 'index' })"
          />
        </div>
        <div class="errorContent__headerImage">
          <img src="/images/404.png" alt="404" />
        </div>
      </div>
    </div>

    <CategoriesSlider :items="categoryMenuData"></CategoriesSlider>

    <div class="errorContent__section" v-if="bestsellers.length">
      <div class="errorContent__sectionHeader">
        <h2 class="errorContent__sectionHeaderTitle">Bestsellery</h2>
      </div>
      <div class="errorContent__sectionSlider">
        <slider-tiles
          :items="bestsellers"
          :slides-per-view="1"
          :breakpoints="{
            600: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          }"
          nav-buttons-type="rounded"
        />
      </div>
    </div>

    <div class="errorContent__section" v-if="priceAlert.length">
      <div class="errorContent__sectionHeader">
        <h2 class="errorContent__sectionHeaderTitle">Hity cenowe</h2>
        <div class="errorContent__sectionHeaderLink">
          <border-link :to="localePath({ name: 'promotions' })" text="zobacz więcej" />
        </div>
      </div>
      <div class="errorContent__sectionSlider">
        <slider-tiles
          :items="priceAlert"
          :slides-per-view="1"
          :breakpoints="{
            600: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          }"
          nav-buttons-type="rounded"
        />
      </div>

      <div class="errorContent__mobileLink">
        <border-link :to="localePath({ name: 'promotions' })" text="zobacz więcej" />
      </div>
    </div>
    <div class="errorContent__section" v-if="articles.length">
      <div class="errorContent__sectionHeader">
        <h2 class="errorContent__sectionHeaderTitle">Najnowsze artykuły</h2>
        <div class="errorContent__sectionHeaderLink">
          <border-link :to="localePath({ name: 'blog' })" text="zobacz wszystkie" />
        </div>
      </div>
      <div class="errorContent__sectionSlider errorContent__sectionSlider--news">
        <slider-tiles
          :items="articles"
          :slides-per-view="1"
          content-type="news"
          :breakpoints="{
            600: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          }"
          nav-buttons-type="rounded"
        />
      </div>

      <div class="errorContent__mobileLink">
        <border-link :to="localePath({ name: 'blog' })" text="zobacz wszystkie" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Qs from 'qs';
import CategoriesSlider from '@/components/CategoriesSlider';
import SliderTiles from '@/components/Sliders/SliderTiles';
import BorderLink from '@/components/BorderLink';
import VButton from '@/components/VButton';

export default {
  name: 'ErrorContent',
  components: { VButton, BorderLink, SliderTiles, CategoriesSlider },
  data() {
    return {
      bestsellers: [],
      priceAlert: [],
      articles: [],
    };
  },
  async fetch() {
    try {
      await this.fetchCategoryMenuData();

      const recommendedParams = {
        filters: { recommended: 1 },
        orderBy: 'createdAt',
        orderDirection: 'desc',
      };
      const result = await Promise.all([
        this.$axios
          .get(`${this.$config.baseOfixApi}/e-commerce/v1/products/bestsellers`, {
            useCache: true,
          })
          .then(response => {
            return response;
          })
          .catch(() => {
            return [];
          }),
        this.$axios
          .get(`${this.$config.baseOfixApi}/e-commerce/v1/products/price-alert`, {
            useCache: true,
          })
          .then(response => {
            return response;
          })
          .catch(() => {
            return [];
          }),
        this.$axios
          .get(`${this.$config.baseOfixApi}/e-commerce/v1/contents`, {
            params: recommendedParams,
            paramsSerializer: params => {
              return Qs.stringify(params, { arrayFormat: 'brackets' });
            },
            useCache: true,
          })
          .then(response => {
            return response;
          })
          .catch(() => {
            return [];
          }),
        this.fetchCategoryMenuData,
      ]);

      this.bestsellers = result[0]?.data?.products;
      this.priceAlert = result[1]?.data?.products;
      this.articles = result[2]?.data?.contents;
    } catch {}
  },
  computed: {
    ...mapState('layout', ['categoryMenuData']),
  },
  methods: {
    ...mapActions({
      fetchCategoryMenuData: 'layout/fetchCategoryMenuData',
    }),
  },
};
</script>

<style scoped lang="scss">
.errorContent {
  &__header {
    padding: 2rem;
    background: $cWhite;
    margin-top: 5rem;
    margin-bottom: 3rem;
  }

  &__headerTitle {
    margin-bottom: 1rem;
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 700;

    @include rwd('tablet') {
      font-size: 3rem;
      line-height: 4rem;
      margin-bottom: 0.6rem;
    }
  }

  &__headerText {
    color: $cMainNeutral;
    font-size: 1.8rem;
    line-height: 2.6rem;
    margin-bottom: 2rem;
  }

  &__headerInner {
    display: flex;
    align-items: center;
    background: $cBg;
    padding: 8rem 5rem;

    @include rwd('tablet') {
      flex-wrap: wrap;
      padding: 4rem 2rem;
    }
  }

  &__headerContent {
    flex: 1;

    @include rwd('tablet') {
      flex: 0 0 100%;
      text-align: center;
    }
  }

  &__headerImage {
    flex: 1;
    text-align: center;

    img {
      max-width: 90%;
    }

    @include rwd('tablet') {
      flex: 0 0 100%;
      margin-top: 3rem;
    }
  }

  &__section {
    background: $cWhite;
    margin-bottom: 3rem;
  }

  &__sectionSlider {
    padding: 0 8px 3rem;

    &--news {
      padding: 0 3rem 3rem;
    }
  }

  &__mobileLink {
    display: none;

    @include rwd('tablet') {
      display: block;
      padding-top: 1rem;
      text-align: center;
      padding-bottom: 3rem;
    }
  }

  &__sectionHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3rem;

    @include rwd('small-tablet') {
      padding: 2rem;
    }
  }

  &__sectionHeaderLink {
    display: block;

    @include rwd('tablet') {
      display: none;
    }
  }

  &__sectionHeaderTitle {
    font-size: 3rem;
    line-height: 4rem;
    font-weight: 600;

    @include rwd('tablet') {
      font-size: 2.6rem;
      line-height: 3.2rem;
    }
  }
}
</style>
